export default "./dist/stdassets/images/icons/iconNavigator.png";